// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-accordion-container {
    width: 100%;
    color: #20303F;
}

.accordion-summary {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #42526B;
    font-size: var(--font-size6);

    & p {
        margin: 0;
        font-weight: bold;
    }
}

.accordion-icon {
    width: 50px;
    height: 50px;
}

.accordion-details-container {
    display: flex;
    justify-content: center;
    gap: 3rem;
}

.accordian-image {
    width: 40%;
}

.accordion-details-right {
    width: 40%;
}

.accordion-details-heading {
    font-size: var(--font-size5);
    font-weight: 700;
    margin: 0;
}

.accordion-details-desc {
    font-size: var(--font-size8);
}

.accordion-detail-bold {
    font-weight: bold;
}

.accordion-details-btn {
    display: flex;
    justify-content: end;
}

@media screen and (min-width:300px) and (max-width:490px) {
    .accordion-summary {
        font-size: 1rem;
    }

    .accordion-icon {
        width: 40px;
        height: 40px;
    }

    .accordion-details-container {
        flex-direction: column;
        gap: 1rem;

        & img {
            width: 100%;
        }
    }

    .accordion-details-right {
        width: 100%;
    }

    .accordion-details-heading {
        font-size: 1rem;
        width: 100%;
    }

    .accordion-details-desc {
        font-size: 0.875rem;
    }
}

@media screen and (min-width:601px) and (max-width:840px) {
    .accordion-summary {
        font-size: 1.3rem;
    }

    .accordion-icon {
        width: 50px;
        height: 50px;
    }

    .accordion-details-container {
        flex-direction: column;
        gap: 1rem;

        & img {
            width: 80%;
        }
    }

    .accordion-details-right {
        width: 100%;
    }

    .accordion-details-heading {
        font-size: 1.3rem;
        width: 100%;
    }

    .accordion-details-desc {
        font-size: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/ServiceAccordion.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,4BAA4B;;IAE5B;QACI,SAAS;QACT,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,SAAS;;QAET;YACI,WAAW;QACf;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,SAAS;;QAET;YACI,UAAU;QACd;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".service-accordion-container {\r\n    width: 100%;\r\n    color: #20303F;\r\n}\r\n\r\n.accordion-summary {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n    color: #42526B;\r\n    font-size: var(--font-size6);\r\n\r\n    & p {\r\n        margin: 0;\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.accordion-icon {\r\n    width: 50px;\r\n    height: 50px;\r\n}\r\n\r\n.accordion-details-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 3rem;\r\n}\r\n\r\n.accordian-image {\r\n    width: 40%;\r\n}\r\n\r\n.accordion-details-right {\r\n    width: 40%;\r\n}\r\n\r\n.accordion-details-heading {\r\n    font-size: var(--font-size5);\r\n    font-weight: 700;\r\n    margin: 0;\r\n}\r\n\r\n.accordion-details-desc {\r\n    font-size: var(--font-size8);\r\n}\r\n\r\n.accordion-detail-bold {\r\n    font-weight: bold;\r\n}\r\n\r\n.accordion-details-btn {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .accordion-summary {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .accordion-icon {\r\n        width: 40px;\r\n        height: 40px;\r\n    }\r\n\r\n    .accordion-details-container {\r\n        flex-direction: column;\r\n        gap: 1rem;\r\n\r\n        & img {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .accordion-details-right {\r\n        width: 100%;\r\n    }\r\n\r\n    .accordion-details-heading {\r\n        font-size: 1rem;\r\n        width: 100%;\r\n    }\r\n\r\n    .accordion-details-desc {\r\n        font-size: 0.875rem;\r\n    }\r\n}\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n    .accordion-summary {\r\n        font-size: 1.3rem;\r\n    }\r\n\r\n    .accordion-icon {\r\n        width: 50px;\r\n        height: 50px;\r\n    }\r\n\r\n    .accordion-details-container {\r\n        flex-direction: column;\r\n        gap: 1rem;\r\n\r\n        & img {\r\n            width: 80%;\r\n        }\r\n    }\r\n\r\n    .accordion-details-right {\r\n        width: 100%;\r\n    }\r\n\r\n    .accordion-details-heading {\r\n        font-size: 1.3rem;\r\n        width: 100%;\r\n    }\r\n\r\n    .accordion-details-desc {\r\n        font-size: 1rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
